import { render, staticRenderFns } from "./SsutInfoIcon.vue?vue&type=template&id=3b4fba55&"
import script from "./SsutInfoIcon.vue?vue&type=script&lang=js&"
export * from "./SsutInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports